/* -------------------------------------------------------------------------- */
/*                                    Units                                   */
/* -------------------------------------------------------------------------- */

/**
 * Array of unit objects with unique IDs and corresponding labels.
 * @type {Array<{ id: string, label: string }>}
 */
export const UNITS = [
	{ id: 'item', label: 'item' },
	{ id: 'ITEM', label: 'item' },
	{ id: 'tco2eq', label: 'tCO2e' },
	{ id: 'tco2e', label: 'tCO2e' },
	{ id: 'tco2', label: 'tCO2' },
	{ id: 'co2e', label: 'CO2e' },
	{ id: 'mwh', label: 'MWh' },
	{ id: 'kwh', label: 'kWh' },
	{ id: 'gco2e', label: 'gCO2e' },
	{ id: 'kg', label: 'kg' },
	{ id: 't', label: 't' },
	{ id: 'gCO2perItem', label: 'gCO2e/item' },
	{ id: 'gCO2perKwh', label: 'gCO2e/kWh' },
	{ id: 'gCO2pert', label: 'gCO2/t' },
	{ id: 'gCO2perKg', label: 'gCO2e/kg' },
	{ id: 'gCO2perMwh', label: 'gCO2e/MWh' },
];

export enum ENUM_UNITS {
	KWH = 'kWh',
	MWH = 'MWh',
	t = 't',
	kg = 'kg',
	KG = 'kg',
	tco2e = 'tCO2e',
	ITEM = 'item',
}
